import React from 'react';
import {
  Card,
  Avatar,
  Row,
  Col,
  Typography,
  Divider,
  List,
  Tag,
  Button,
  Space,
  Timeline
} from 'antd';
import {
  UserOutlined,
  EnvironmentOutlined,
  MailOutlined,
  PhoneOutlined,
  GithubOutlined,
  WechatOutlined,
  BookOutlined,
  TrophyOutlined,
  HeartOutlined
} from '@ant-design/icons';
import './index.css';

const { Title, Text, Paragraph } = Typography;

const About = () => {
  const skills = [
    { name: 'React', level: 90, color: '#61dafb' },
    { name: 'Vue.js', level: 85, color: '#42b883' },
    { name: 'TypeScript', level: 80, color: '#3178c6' },
    { name: 'Node.js', level: 85, color: '#68a063' },
    { name: 'Python', level: 75, color: '#3776ab' },
    { name: 'Docker', level: 70, color: '#2496ed' },
  ];

  const experiences = [
    {
      year: '2023 - 至今',
      company: '某科技公司',
      position: '前端开发工程师',
      description: '负责核心产品的前端架构设计和开发'
    },
    {
      year: '2021 - 2023',
      company: '某互联网公司',
      position: '全栈开发工程师',
      description: '参与多个项目的全栈开发和维护'
    },
    {
      year: '2019 - 2021',
      company: '某软件公司',
      position: 'Web开发工程师',
      description: '负责企业级应用的前端开发'
    }
  ];

  const hobbies = [
    '编程', '阅读', '摄影', '旅行', '音乐', '篮球',
    '电影', '烹饪', '游戏', '爬山', '游泳', '书法'
  ];

  return (
    <div className="about-page">
      {/* 个人介绍卡片 */}
      <Card className="profile-card">
        <Row gutter={[32, 32]} align="middle">
          <Col xs={24} md={6} className="avatar-col">
            <Avatar
              size={160}
              icon={<UserOutlined />}
              src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop"
              className="profile-avatar"
            />
          </Col>
          
          <Col xs={24} md={18}>
            <div className="profile-info">
              <Title level={2} className="profile-name">张三</Title>
              <Title level={4} type="secondary" className="profile-title">
                全栈开发工程师 & 技术博主
              </Title>
              
              <Paragraph className="profile-bio">
                热爱编程，热衷于探索新技术，享受将想法转化为产品的过程。
                我相信技术改变世界，代码成就梦想。
                在这个博客里，我分享技术经验、生活感悟和学习心得。
              </Paragraph>
              
              <div className="profile-contacts">
                <Space size="large" wrap>
                  <div className="contact-item">
                    <EnvironmentOutlined />
                    <Text>上海</Text>
                  </div>
                  <div className="contact-item">
                    <MailOutlined />
                    <Text>zhangsan@example.com</Text>
                  </div>
                  <div className="contact-item">
                    <PhoneOutlined />
                    <Text>+86 138-0013-8000</Text>
                  </div>
                </Space>
              </div>
              
              <div className="profile-social">
                <Space size="middle">
                  <Button 
                    type="text" 
                    icon={<GithubOutlined />}
                    href="https://github.com"
                    target="_blank"
                    className="social-btn"
                  >
                    GitHub
                  </Button>
                  <Button 
                    type="text" 
                    icon={<WechatOutlined />}
                    className="social-btn"
                  >
                    微信
                  </Button>
                  <Button 
                    type="primary"
                    icon={<MailOutlined />}
                  >
                    联系我
                  </Button>
                </Space>
              </div>
            </div>
          </Col>
        </Row>
      </Card>

      <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
        {/* 技能特长 */}
        <Col xs={24} md={12}>
          <Card title="技能特长" className="section-card">
            <div className="skills-section">
              {skills.map(skill => (
                <div key={skill.name} className="skill-item">
                  <div className="skill-header">
                    <Text strong>{skill.name}</Text>
                    <Text type="secondary">{skill.level}%</Text>
                  </div>
                  <div className="skill-bar">
                    <div 
                      className="skill-progress"
                      style={{ 
                        width: `${skill.level}%`,
                        backgroundColor: skill.color
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </Col>

        {/* 工作经历 */}
        <Col xs={24} md={12}>
          <Card title="工作经历" className="section-card">
            <Timeline className="experience-timeline">
              {experiences.map((exp, index) => (
                <Timeline.Item key={index}>
                  <div className="experience-item">
                    <Text strong className="experience-year">{exp.year}</Text>
                    <Title level={5} className="experience-company">
                      {exp.company}
                    </Title>
                    <Tag color="blue" className="experience-position">
                      {exp.position}
                    </Tag>
                    <Text type="secondary" className="experience-desc">
                      {exp.description}
                    </Text>
                  </div>
                </Timeline.Item>
              ))}
            </Timeline>
          </Card>
        </Col>

        {/* 兴趣爱好 */}
        <Col xs={24}>
          <Card title="兴趣爱好" className="section-card">
            <div className="hobbies-section">
              {hobbies.map(hobby => (
                <Tag
                  key={hobby}
                  icon={<HeartOutlined />}
                  className="hobby-tag"
                  color="magenta"
                >
                  {hobby}
                </Tag>
              ))}
            </div>
          </Card>
        </Col>

        {/* 博客统计 */}
        <Col xs={24}>
          <Card title="博客统计" className="section-card">
            <Row gutter={[16, 16]}>
              <Col xs={12} sm={6}>
                <div className="stat-item">
                  <Title level={1} className="stat-number" style={{ color: '#1890ff' }}>
                    156
                  </Title>
                  <Text type="secondary">文章数量</Text>
                </div>
              </Col>
              <Col xs={12} sm={6}>
                <div className="stat-item">
                  <Title level={1} className="stat-number" style={{ color: '#52c41a' }}>
                    25.8K
                  </Title>
                  <Text type="secondary">阅读总量</Text>
                </div>
              </Col>
              <Col xs={12} sm={6}>
                <div className="stat-item">
                  <Title level={1} className="stat-number" style={{ color: '#faad14' }}>
                    368
                  </Title>
                  <Text type="secondary">评论数量</Text>
                </div>
              </Col>
              <Col xs={12} sm={6}>
                <div className="stat-item">
                  <Title level={1} className="stat-number" style={{ color: '#f5222d' }}>
                    3年+
                  </Title>
                  <Text type="secondary">博客年龄</Text>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default About;